import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { yeuCauHoTroGroupApi } from "../../../api/yeuCauHoTroGroupApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eYCHTGroupActionTypeIds, IYCHTGroupDeleteStart, IYCHTGroupSaveStart } from "../../action-types/danh-muc/IYCHTGroupActionTypes";
import { actions } from "../../actions/actionsWrapper";


export function* ychtGroupSaga(): any {
    yield takeLatest(eYCHTGroupActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eYCHTGroupActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eYCHTGroupActionTypeIds.SAVE_START, saveWorker)
}
function* loadWorker(): any {

    const res: IBaseResponeModel = yield call([yeuCauHoTroGroupApi, yeuCauHoTroGroupApi.SelectAll])
    if (res.is_success) {
        yield put(actions.ychtGroupActions.loadSuccess(res.data))
    } else {
        yield put(actions.ychtGroupActions.loadError(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IYCHTGroupDeleteStart): any {
    const res: IBaseResponeModel = yield call([yeuCauHoTroGroupApi, yeuCauHoTroGroupApi.DeleteMultiple], action.payload)
    if (res.is_success) {
        yield put(actions.ychtGroupActions.deleteSuccess())
    } else {
        yield put(actions.ychtGroupActions.deleteError(res.message || "Không xóa được tuần"))
    }
}
function* saveWorker(action: IYCHTGroupSaveStart): any {
    let res: IBaseResponeModel;
    if (action.payload.id > 0) {
        res = yield call([yeuCauHoTroGroupApi, yeuCauHoTroGroupApi.Update], action.payload);
    } else {
        res = yield call([yeuCauHoTroGroupApi, yeuCauHoTroGroupApi.Insert], action.payload);
    }
    if (res.is_success) {
        yield put(actions.ychtGroupActions.saveSuccess())
    } else {
        yield put(actions.ychtGroupActions.saveError(res.message || "Không lưu được tuần"))
    }
}
